import { isDev } from '@constants/environments';
import useUser from '@hooks/auth/useUser';
import useProject from '@hooks/useProject';
import { useStack } from '@stackflow/react';
import { installGTM, pushGtmEvent, setGtmUser } from '@utils/gtm';
import { useEffect, useRef, useState } from 'react';

function useGoogleAnalytics() {
    const [isInitialized, setIsInitialized] = useState<boolean>(false);
    const { user } = useUser();
    const stack = useStack();
    const lastActivityIdRef = useRef<string | undefined>(undefined);
    const project = useProject();
    const trackingId = project?.gaTrackingId;

    useEffect(() => {
        if (!isInitialized && !isDev && trackingId) {
            installGTM({ gtmId: trackingId });
            setIsInitialized(true);
        }
    }, [isInitialized, trackingId]);

    useEffect(() => {
        if (isInitialized && user) {
            setGtmUser(user.barcodeNo);
        }
    }, [user, isInitialized]);

    useEffect(() => {
        if (!isInitialized || isDev) {
            return;
        }
        const activeActivity = stack.activities.find((it) => it.isActive && it.isTop);
        if (!activeActivity || lastActivityIdRef.current === activeActivity.id) {
            return;
        }
        lastActivityIdRef.current = activeActivity.id;
        const queryString = new URLSearchParams(
            Object.entries(activeActivity.params).map(([key, value]) => [key, String(value)]),
        ).toString();

        pushGtmEvent({
            event: 'page_view',
            activity_name: activeActivity.name,
            queryString,
            url: window.location.href,
        });
    }, [stack, isInitialized]);
}

export default useGoogleAnalytics;
